import { render, staticRenderFns } from "./OrderPaymentsList.vue?vue&type=template&id=0895c2f9&"
import script from "./OrderPaymentsList.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports